import { MenusArchives } from '../Datas/MenusArchives.js';
import { MenusClassement } from '../Datas/MenusClassement.js';
import { MenusPersonnages } from '../Datas/MenusPersonnages.js';

export const BlockMenuPublic = (props) => {
    const { label, showSub, setShowSub } = props;
    let nb =  0;
    let title, datas, css, values;
    if (label.match(/park/)) {
        datas = props.park.univers;
        title =  props.park.pname;
    }
    if (label === 'park-1') {
        nb =  1;
        css = { bkg: 'link-white bkg-nav-park', brd: 'link-white border-nav-park' };
    }
    if (label === 'park-2') {
        nb =  2;
        css = { bkg: 'link-white bkg-nav-studio', brd: 'link-white border-nav-studio' };
    }
    if (label === 'history') {
        nb =  3;
        datas = MenusArchives();
        title =  'Il était une fois...';
        css = { bkg: 'bkg-nav-green', brd: 'border-nav-green' };
    }
    if (label === 'character') {
        nb =  4;
        datas = MenusPersonnages();
        title =  'Personnages Disney';
        css = { bkg: 'bkg-nav-blue', brd: 'border-nav-blue' };
    }
    if (label === 'classement') {
        nb =  5
        datas = MenusClassement();
        title =  'Classements';
        css = { bkg: 'bkg-nav-pink', brd: 'border-nav-pink' };
    }
    return (
        <div className="nav-parent">
            <div className={`link ${css.bkg}`} onClick={() => { setShowSub(nb) }}>{title}</div>
            <div className={`nav-childs ${showSub === nb ? 'show' : 'hide'}`}>
                {datas.map((e, i) => {
                    if (label.match(/park/)) {
                        values = { href: e.uroute, name: e.uname };
                    } else {
                        values = { href: e.href, name: e.name };
                    }
                    return (
                        <a className={`link ${css.brd}`} href={values.href} alt={values.name} key={i}>{values.name}</a>
                    )
                })}
            </div>
        </div>
    )
}